import * as actionType from "../ActionTypes";
import * as mutationType from "../MutationType";
import api from "../../config/api";
const state = {

};
const getters = {
  
};

const actions = {
    [actionType.GET_MEDIA]: async function ({commit}, params){
        return new Promise((resolve,reject) => {
            api('/admin/site-files', {
                method:"GET",
                params : params
            }).then(result => {
                resolve(result)
            }).catch(error => reject(error))
        })
    },
    [actionType.ADD_FILES]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
          api.post(`/admin/site-files`,params).then(result => {
            resolve(result);
          })
            .catch(error => reject(error));
        });
    },
    [actionType.UPDATE_FILES]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
          api.put(`/admin/site-files/${params.mediaId}`,params.filesData).then(result => {
            resolve(result);
          })
            .catch(error => reject(error));
        });
    },
    [actionType.DELETE_FILE]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
          api.delete(`/admin/site-files/${params.id}`,).then(result => {
            resolve(result);
          })
            .catch(error => reject(error));
        });
    },
};

const mutations = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}